import { Currency, Token } from '@kodiak-finance/sdk-core'
import { nativeOnChain, WRAPPED_NATIVE_CURRENCY } from 'constants/tokens'
import { useConnection } from 'hooks/useConnection'
import { useCallback, useMemo } from 'react'

const isNativeCurrencyOrWrapped = (currency: Currency, wrappedNative: Token): boolean => {
  return currency.isNative || wrappedNative.equals(currency.wrapped)
}

export const useNativeCurrencyPreference = (receiveWrapped: boolean) => {
  const { chainId } = useConnection()

  const nativeCurrency = useMemo(() => nativeOnChain(chainId), [chainId])
  const wrappedNative = useMemo(() => WRAPPED_NATIVE_CURRENCY[chainId], [chainId])

  const getCurrencyWithPreference = useCallback(
    (currency: Currency) => {
      if (!isNativeCurrencyOrWrapped(currency, wrappedNative)) {
        return currency
      }

      return receiveWrapped ? wrappedNative : nativeCurrency
    },
    [nativeCurrency, receiveWrapped, wrappedNative]
  )

  const shouldShowNativeCurrencyToggle = useCallback(
    (currencyA: Currency | undefined, currencyB: Currency | undefined) => {
      if (!currencyA || !currencyB) return false
      return isNativeCurrencyOrWrapped(currencyA, wrappedNative) || isNativeCurrencyOrWrapped(currencyB, wrappedNative)
    },
    [wrappedNative]
  )

  return {
    nativeCurrency,
    wrappedNative,
    getCurrencyWithPreference,
    shouldShowNativeCurrencyToggle,
  }
}
